import React, { useState } from 'react';
import { Btn, C } from '../../../components/UI';
import { api, MarketplaceAppDetailDto } from '../../../services/api';

interface ApiKeyField { key: string; label: string; secret?: boolean; }

// The one generic piece of the marketplace setup flow — a new ApiKeyEntry-style app never needs
// its own frontend component, just a SetupConfigJson field spec on the MarketplaceApp row.
export default function AppSetupModal({ app, onClose, onDone }: {
    app: MarketplaceAppDetailDto;
    onClose: () => void;
    onDone: () => void;
}) {
    const [values, setValues] = useState<Record<string, string>>({});
    const [working, setWorking] = useState(false);
    const [error, setError] = useState('');

    const fields: ApiKeyField[] = (() => {
        try { return app.setupConfigJson ? JSON.parse(app.setupConfigJson) : []; }
        catch { return []; }
    })();

    const submit = async () => {
        setWorking(true);
        setError('');
        try {
            await api.configureApp(app.id, values);
            onDone();
        } catch (e: any) {
            setError(e.message || 'Something went wrong.');
        } finally {
            setWorking(false);
        }
    };

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={onClose}>
            <div onClick={e => e.stopPropagation()} style={{ background: C.card, borderRadius: 14, padding: 26, width: '100%', maxWidth: 420 }}>
                <h3 style={{ margin: '0 0 4px', fontSize: 17, fontWeight: 700, color: C.text }}>Connect {app.name}</h3>
                <p style={{ margin: '0 0 18px', fontSize: 13, color: C.textSub }}>Enter your {app.name} credentials to finish setup.</p>

                {fields.map(f => (
                    <div key={f.key} style={{ marginBottom: 14 }}>
                        <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: C.textSub, marginBottom: 5 }}>{f.label}</label>
                        <input
                            type={f.secret ? 'password' : 'text'}
                            value={values[f.key] || ''}
                            onChange={e => setValues(v => ({ ...v, [f.key]: e.target.value }))}
                            style={{ width: '100%', padding: '10px 12px', border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
                        />
                    </div>
                ))}

                {error && <div style={{ color: '#D84040', fontSize: 13, marginBottom: 12 }}>{error}</div>}

                <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
                    <Btn variant="outline" onClick={onClose} fullWidth>Cancel</Btn>
                    <Btn onClick={submit} disabled={working || fields.some(f => !values[f.key])} fullWidth>
                        {working ? 'Connecting…' : 'Connect'}
                    </Btn>
                </div>
            </div>
        </div>
    );
}
